import { supabase } from './supabase';

export async function addEmailSignup(email: string): Promise<void> {
  const cleaned = email.trim().toLowerCase();
  if (!cleaned) throw new Error('Email is required');

  const { error } = await supabase.from('email_signups').insert({ email: cleaned });
  if (!error) return;

  // Ignore duplicate signups
  if ((error as { code?: string }).code === '23505') return;

  throw new Error(error.message);
}

